import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const Instruction = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const instructors = [
    {
      name: "Instructor Name",
      role: "Web Design & Development",
      img: "/assets/img/team-1.jpg"
    },
    {
      name: "Instructor Name",
      role: "Web Design & Development",
      img: "/assets/img/team-2.jpg"
    },
    {
      name: "Instructor Name",
      role: "Web Design & Development",
      img: "/assets/img/team-3.jpg"
    },
    {
      name: "Instructor Name",
      role: "Web Design & Development",
      img: "/assets/img/team-4.jpg"
    }
  ];

  return (
    <div>
      {/* Header Section */}
      <div className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom" style={{ marginBottom: '90px' }}>
        <div className="container text-center py-5">
          <h1 className="text-white display-1">Instructors</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase"><a className="text-white" href="/">Home</a></p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">Instructors</p>
          </div>
          <div className="mx-auto mb-5" style={{ width: '100%', maxWidth: '600px' }}>
            <div className="input-group">
              <div className="input-group-prepend">
                <button className="btn btn-outline-light bg-white text-body px-4 dropdown-toggle" type="button">
                  Courses
                </button>
              </div>
              <input
                type="text"
                className="form-control border-light"
                style={{ padding: '30px 25px' }}
                placeholder="Keyword"
              />
              <div className="input-group-append">
                <button className="btn btn-secondary px-4 px-lg-5">Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Instructors Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="section-title text-center position-relative mb-5">
            <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">Instructors</h6>
            <h1 className="display-4">Meet Our Instructors</h1>
          </div>

          <Slider {...settings}>
            {instructors.map((inst, index) => (
              <div className="p-3" key={index}>
                <div className="team-item">
                  <img className="img-fluid w-100" src={inst.img} alt={inst.name} />
                  <div className="bg-light text-center p-4">
                    <h5 className="mb-3">{inst.name}</h5>
                    <p className="mb-2">{inst.role}</p>
                    <div className="d-flex justify-content-center">
                      <a className="mx-1 p-1" href="#"><i className="fab fa-twitter"></i></a>
                      <a className="mx-1 p-1" href="#"><i className="fab fa-facebook-f"></i></a>
                      <a className="mx-1 p-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                      <a className="mx-1 p-1" href="#"><i className="fab fa-instagram"></i></a>
                      <a className="mx-1 p-1" href="#"><i className="fab fa-youtube"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
